"use strict";

define('model/assignment',['require','exports','module','./base','datakit/util/url','datakit/ajax'],function (require, exports, module) {
  var Model = require('./base');
  var url = require('datakit/util/url');
  var Ajax = require('datakit/ajax');
  var Assignment = Model.extend({
    virtual: {
      'displayName': Model.createKeyPathVirtual('person.displayName'),
      'primaryPhone': Model.createKeyPathVirtual('person.primaryPhone'),
      'primaryEmail': Model.createKeyPathVirtual('person.primaryEmail'),
      'organization.title': Model.createKeyPathVirtual('organization.title'),
      'assignmentType.displayName': Model.createKeyPathVirtual('assignmentType.displayName'),
      'assignmentTypeDescription': Model.createKeyPathVirtual('assignmentType.description'),
      'personId': Model.createKeyPathVirtual('person.id'),
      'sponsor.name': Model.createKeyPathVirtual('sponsor.name')
    },
    childModels: {
      person: 'Person',
      group: 'Group',
      alternateFor: 'Person',
      organization: 'Organization',
      assignmentType: 'AssignmentType'
    },
    requestChangeAnalyst: function requestChangeAnalyst(docId) {
      var urlLink = url.template('/rs/api/assignment/changeAnalyst/:documentId/:personId', {
        documentId: docId,
        personId: this.get('person').get('id')
      });
      return this.request({
        url: urlLink,
        type: 'POST'
      });
    },
    requestChangeOrganization: function requestChangeOrganization(studyId, orgAssignmentTypeId) {
      var urlLink = url.template('/rs/api/assignment/organization/study/:studyId', {
        studyId: studyId
      });
      var value = this.get('value');
      var updateArray = [];
      this.clear({
        silent: true
      });
      if (value) {
        updateArray.push({
          id: value.id,
          assignmentTypeId: orgAssignmentTypeId
        });
        var options = {
          url: urlLink,
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(updateArray)
        };
        return Ajax.request(options);
      } else {
        return false;
      }
    },
    toJSON: function toJSON() {
      var attr = _.clone(this.attributes),
        assignmentType = attr.assignmentType,
        jsonProps = {};
      if (assignmentType) {
        jsonProps.assignmentTypeId = attr.assignmentType.id;
      } else {
        return jsonProps;
      }
      if (Assignment.PersonType.indexOf(assignmentType.get('description')) > -1) {
        jsonProps.id = attr.person ? attr.person.id : null;
        jsonProps.groupId = attr.group ? attr.group.id : null;
        if (attr.alternateFor) {
          jsonProps.alternateForId = attr.alternateFor.id;
        }
      } else if (Assignment.GroupType.indexOf(assignmentType.get('description')) > -1) {
        jsonProps.id = attr.group ? attr.group.id : null;
      } else {
        jsonProps.value = attr.value;
      }
      return jsonProps;
    }
  }, {});
  Assignment.PersonType = ['PRINCIPAL_INVESTIGATOR', 'CO_PRINCIPAL_INVESTIGATOR', 'PRIMARY_CONTACT', 'INVESTIGATOR', 'IRB_ORG_APPROVER', 'IRB_ANALYST', 'IRB_REVIEWER_PRIMARY', 'IRB_REVIEWER_SECONDARY', 'IRB_FULL_EXPEDITED_REVIEWER', 'IRB_REVIEWER'];
  Assignment.GroupType = ['IRB_BOARD'];
  module.exports = Assignment;
});

